var _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRestoreAva(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#1C63D5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4904_64642",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4904_64642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 26.6668V25.0002H15.6041C14.8958 24.3891 14.3402 23.6529 13.9374 22.7918C13.5346 21.9307 13.3333 21.0002 13.3333 20.0002C13.3333 18.4446 13.8055 17.0729 14.7499 15.8852C15.6944 14.6979 16.8888 13.9168 18.3333 13.5418V15.2918C17.361 15.6391 16.5624 16.2396 15.9374 17.0935C15.3124 17.9479 14.9999 18.9168 14.9999 20.0002C14.9999 20.7502 15.1491 21.4413 15.4474 22.0735C15.7463 22.7052 16.1527 23.2502 16.6666 23.7085V21.6668H18.3333V26.6668H13.3333ZM22.4999 26.6668C21.8055 26.6668 21.2152 26.4238 20.7291 25.9377C20.243 25.4516 19.9999 24.8613 19.9999 24.1668C19.9999 23.5002 20.2291 22.9274 20.6874 22.4485C21.1458 21.9691 21.7083 21.7154 22.3749 21.6877C22.611 21.1877 22.9619 20.7813 23.4274 20.4685C23.8924 20.1563 24.4166 20.0002 24.9999 20.0002C25.736 20.0002 26.3716 20.2399 26.9066 20.7193C27.441 21.1982 27.7638 21.7918 27.8749 22.5002C28.4583 22.5002 28.9583 22.7016 29.3749 23.1043C29.7916 23.5071 29.9999 23.9932 29.9999 24.5627C29.9999 25.146 29.7985 25.6424 29.3958 26.0518C28.993 26.4618 28.4999 26.6668 27.9166 26.6668H22.4999ZM24.9166 19.1668C24.8194 18.5974 24.6319 18.0696 24.3541 17.5835C24.0763 17.0974 23.736 16.6668 23.3333 16.2918V18.3335H21.6666V13.3335H26.6666V15.0002H24.3958C24.993 15.5279 25.4827 16.146 25.8649 16.8543C26.2466 17.5627 26.493 18.3335 26.6041 19.1668H24.9166ZM22.4999 25.0002H27.9166C28.0277 25.0002 28.1249 24.9585 28.2083 24.8752C28.2916 24.7918 28.3333 24.6946 28.3333 24.5835C28.3333 24.4724 28.2916 24.3752 28.2083 24.2918C28.1249 24.2085 28.0277 24.1668 27.9166 24.1668H26.4583V23.1252C26.4583 22.7224 26.316 22.3785 26.0316 22.0935C25.7466 21.8091 25.4027 21.6668 24.9999 21.6668C24.5971 21.6668 24.2535 21.8091 23.9691 22.0935C23.6841 22.3785 23.5416 22.7224 23.5416 23.1252V23.3335H22.4999C22.2638 23.3335 22.066 23.4135 21.9066 23.5735C21.7466 23.7329 21.6666 23.9307 21.6666 24.1668C21.6666 24.4029 21.7466 24.6007 21.9066 24.7602C22.066 24.9202 22.2638 25.0002 22.4999 25.0002Z",
    fill: "#F2F4F6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestoreAva);
export default __webpack_public_path__ + "static/media/RestoreAva.5d57ea01191d4e0651cee0fe77f2f570.svg";
export { ForwardRef as ReactComponent };